define('UnitOfMeasure.QuantityPricing.Collection', [
    'Backbone.CachedCollection',
    'Utils'
], function UnitOfMeasureQuantityPricingCollection(
    CachedCollection,
    Utils
) {
    'use strict';

    return CachedCollection.extend({
        url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/UnitsOfMeasure.QuantityPrincing.Service.ss'))
    });
});
